// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 53 ? "webfontloader" : chunkId) + "." + {"53":"415c9240","827":"20824ee1","926":"6cc4ba21"}[chunkId] + ".js";
};